export default "__VITE_ASSET__cPJEvzMt__"